import chroma from "chroma-js";


/**
 * @param {object} param
 * @param {string} param.color - The color to generate the gradient from
 * @param {number} param.steps - The number of steps in the gradient
 * @param {string} param.outputFormat - The format of the output color
 * @returns
 */
export function gradientFromMiddleColor({
  color,
  steps = 3,
  outputFormat = "hex",
}) {
  if (!color) throw new Error("A color is required");
  if (typeof color !== "string") throw new Error("Color must be a string");
  if (typeof steps !== "number") throw new Error("Steps must be a number");
  if (steps < 2) throw new Error("Steps must be greater than 1");

  if (outputFormat && typeof outputFormat !== "string")
    throw new Error("Outbound format must be a string");

  const middleColor = chroma(color).shade(0.25);
  const lastColor = chroma(color).shade(0.5);
  const gradient = chroma
    .scale([color, middleColor, lastColor])
    .mode("oklch")
    .correctLightness()
    .colors(steps);
  return gradient;
}